import React, { Component } from "react";
import "./index.css";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";

/* API requests */
import { getYacht } from "../../../../api-requests/yacht";
import { getApplicationsForJob, rejectApplication, restoreApplication, forwardApplication, hireApplication } from "../../../../api-requests/application";

/* Helpers */
import { getJobMatch, timeSinceLastActive, handleYachtName } from "../../../../helpers/job";

import { setAlert } from "../../../../redux/actions/misc";
import { getJob, matchUserToJob, sendJobAlerts, getEmailList } from "../../../../api-requests/job";
import { getPositions } from "../../../../api-requests/position";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from "react-places-autocomplete";

/* ───────── Find candidates chip helpers ───────── */

const FilterChip = ({ label, valueLabel, isActive, isOpen, onToggle, onClear, children }) => (
    <div className={`fc-chip${isActive ? " is-active" : ""}${isOpen ? " is-open" : ""}`}>
        <button type="button" className="fc-chip-button" onClick={onToggle}>
            <span className="fc-chip-label">{label}</span>
            {isActive && valueLabel ? (
                <>
                    <span className="fc-chip-separator">·</span>
                    <span className="fc-chip-value">{valueLabel}</span>
                </>
            ) : (
                <span className="fc-chip-caret" aria-hidden="true">▾</span>
            )}
        </button>
        {isActive && onClear && (
            <button
                type="button"
                className="fc-chip-clear"
                onClick={(e) => { e.stopPropagation(); onClear(); }}
                aria-label={`Clear ${label} filter`}
            >×</button>
        )}
        {isOpen && (
            <div className="fc-chip-popover" role="dialog">
                {children}
            </div>
        )}
    </div>
);

const FilterOption = ({ label, selected, onClick }) => (
    <button
        type="button"
        className={`fc-option${selected ? " is-selected" : ""}`}
        onClick={onClick}
    >
        <span className="fc-option-check" aria-hidden="true">{selected ? "✓" : ""}</span>
        <span className="fc-option-label">{label}</span>
    </button>
);

class Applications extends Component {

    constructor(props) {
        super(props);

        this.state = {
            yacht: {},
            job: {},
            isFetching: true,
            active: [],
            rejected: [],
            forwarded: [],
            hired: [],
            findCandidates: false,
            filterTab: "results",
            filterResults: [],
            isFetchingSearchResults: false,
            sent: [],
            selectedForSending: [],
            allSelected: false,
            resultsSortType: "JOB_MATCH_BEST",
            /* Filters */
            name: "",          
            position: false,
            jobType: false,
            yachtType: false,
            couples: "Include Couples",
            qualifications: false,
            visas: false,
            location: "",
            coords: null,
            nationality: "",
            country: "",
            lastActive: "Don't Match",
            availability: "Don't Match",
            tattoo: false,
            smoking: false,
            yachtLengthMin: "",
            yachtLengthMax: "",
            yachtLengthAny: true,
            ageMin: "",
            ageMax: "",
            ageAny: true,
            salaryMin: "",
            salaryMax: "",
            salaryAny: true,
            salaryCurrency: null,
            profileKeywords: [],
            profileKeyword: "",
            /* Explicit position multi-select (array of position _id strings).
               Empty array → use the legacy `position` boolean below. */
            positions: [],
            positionsSearch: "",       // search text inside the Position chip popover
            availablePositions: [],    // loaded from /api/positions
            /* Chip UI state */
            openFilter: null,         // which filter chip's popover is open
            displayLimit: 50,         // client-side pagination
            appliedHiddenCount: 0,    // candidates excluded because they already applied
        };

        this.searchTimeOut = null;

    }

    componentDidMount() {

        document.getElementById("Dashboard").scrollTo(0, 0);

        // Load the positions catalogue once so the Position chip can offer
        // a searchable picker.
        getPositions()
            .then(result => {
                if (result && Array.isArray(result.data)) {
                    this.setState({ availablePositions: result.data });
                } else if (Array.isArray(result)) {
                    this.setState({ availablePositions: result });
                }
            })
            .catch(() => {});

        return getYacht(this.props.match.params.yachtId)
            .then(yacht => {
                return yacht;
            })
            .then(yacht => {
                return getJob(this.props.match.params.jobId)
                    .then(job => { 
                        return job;
                    })
                    .then(job => {
                        return getApplicationsForJob(this.props.match.params.jobId)
                            .then(applications => {
                                return this.setState({ job: job, yacht: yacht, active: applications.active, rejected: applications.rejected, forwarded: applications.forwarded, hired: applications.hired, isFetching: false, }, () => {
                                    return getEmailList(job.emailList)
                                        .then(sent => {
                                            return this.setState({ sent });
                                        });
                                });
                            });
                    });
            });

    }

    checkIfSearching = () => {

        if (this.state.location) return true;
        if (this.state.name && this.state.name.length > 4) return true;
        if (this.state.nationality && this.state.nationality.length > 4) return true;
        if (this.state.country && this.state.country.length > 4) return true;
        if (this.state.name && this.state.name > 4) return true;
        if (this.state.name && this.state.name > 4) return true;
        if (this.state.position) return true;
        if (this.state.jobType) return true;
        if (this.state.yachtType) return true;
        if (this.state.qualifications) return true;
        if (this.state.visas) return true;
        if (this.state.tattoo) return true;
        if (this.state.smoking) return true;
        if (this.state.jobType) return true;
        if (this.state.couples !== "Include Couples") return true;
        if (this.state.lastActive !== "Don't Match") return true;
        if (this.state.availability !== "Don't Match") return true;
        if (this.state.yachtLengthMin || this.state.yachtLengthMax) return true;
        if (this.state.ageMin || this.state.ageMax) return true;
        if (this.state.salaryMin || this.state.salaryMax) return true;
        if (this.state.salaryCurrency) return true;
        if (this.state.profileKeywords && this.state.profileKeywords.length > 0) return true;
        if (this.state.positions && this.state.positions.length > 0) return true;

        return false;

    }

    handleCurrency = (currency) => {

        if (currency === "eur") return "€";
        if (currency === "usd") return "$";
        if (currency === "gbp") return "£";

        return "";

    }

    handleReject = (_id) => {

        return rejectApplication(_id)
            .then(result => {
                if (result.success) {
                    return getApplicationsForJob(this.props.match.params.jobId)
                        .then(data => {
                            return this.setState({ active: data.active, rejected: data.rejected, forwarded: data.forwarded, hired: data.hired  }, () => {
                                this.props.setAlert("Candidate rejected!", "success", true);
                                return setTimeout(() => {
                                    return this.props.setAlert("Candidate rejected!", "success", false);
                                }, 2700);
                            });
                        });
                }
                return;
            });

    }

    handleRestore = (_id) => {

        return restoreApplication(_id)
            .then(result => {
                if (result.success) {
                    return getApplicationsForJob(this.props.match.params.jobId)
                        .then(data => {
                            return this.setState({ active: data.active, rejected: data.rejected, forwarded: data.forwarded, hired: data.hired  }, () => {
                                this.props.setAlert("Candidate restored!", "success", true);
                                return setTimeout(() => {
                                    return this.props.setAlert("Candidate restored!", "success", false);
                                }, 2700);
                            });
                        });
                }
                return;
            });

    }

    handleForward = (_id) => {

        return forwardApplication(_id)
            .then(result => {
                if (result.success) {
                    return getApplicationsForJob(this.props.match.params.jobId)
                        .then(data => {
                            return this.setState({ active: data.active, rejected: data.rejected, forwarded: data.forwarded, hired: data.hired }, () => {
                                this.props.setAlert("Candidate forwarded!", "success", true);
                                return setTimeout(() => {
                                    return this.props.setAlert("Candidate forwarded!", "success", false);
                                }, 2700);
                            });
                        });
                }
                return;
            });

    }

    handleHire = (_id) => {

        return hireApplication(_id)
            .then(result => {
                if (result.success) {
                    return getApplicationsForJob(this.props.match.params.jobId)
                        .then(data => {
                            return this.setState({ active: data.active, rejected: data.rejected, forwarded: data.forwarded, hired: data.hired }, () => {
                                this.props.setAlert("Candidate hired!", "success", true);
                                return setTimeout(() => {
                                    return this.props.setAlert("Candidate hired!", "success", false);
                                }, 2700);
                            });
                        });
                }
                return;
            });

    }

    newOnesFirst = (a, b) => {

        if (a.status && b.status) {
            
            if (a.status < b.status) return -1;
            if (a.status > b.status) return 1;

            if (a.dateApplied > b.dateApplied) return -1;
            if (a.dateApplied < b.dateApplied) return 1;
    
        }   
    
        return 0;
    
    }

    renderRows = (applications, status) => {

        applications = applications.sort(this.newOnesFirst);

        return applications.map((application, index) => {

            const profile = application.candidate.profile || {};
            const jobMatch = getJobMatch(application.job, profile);
            const isNew = application.status === "applied" && !application.rejected;
            const firstName = profile.firstName || "";
            const lastName = profile.lastName || "";
            const initials = `${firstName[0] || ""}${lastName[0] || ""}`.toUpperCase() || "?";
            const nationality = Array.isArray(profile.nationality) && profile.nationality.length ? profile.nationality[0] : "";
            const location = profile?.currentLocation?.name || profile.country || "";
            const metaParts = [nationality, location, application.dateApplied].filter(Boolean);

            return(
                <div key={index} className={`application-row-container${isNew ? " is-new" : ""}`}>
                    <Link className="application-row-clickable-container" to={this.props.match.path.includes("/yachts") ? `/yachts/listings/${this.state.yacht._id}/applications/${this.state.job._id}/application/${application._id}` : `/listings/applications/${this.state.yacht._id}/job/${this.state.job._id}/application/${application._id}`}>
                        <div className="application-row-details-container">
                            <div className="application-row-image-container">
                                {profile.profileImage ? (
                                    <img src={profile.profileImage} onError={(e) => { e.target.onerror = null; e.target.style.display = "none"; }} alt="" />
                                ) : (
                                    <div className="application-row-avatar-fallback" aria-hidden="true">{initials}</div>
                                )}
                            </div>
                            <div className="application-row-name-container">
                                <div className="application-row-name-team-container">
                                    <p>{firstName} {lastName}</p>
                                    {profile?.couple?.status === "linked" &&
                                        <strong>TEAM</strong>
                                    }
                                </div>
                                {metaParts.length > 0 &&
                                    <div className="application-row-meta">
                                        {metaParts.map((part, i) => (
                                            <React.Fragment key={i}>
                                                {i > 0 && <span className="application-row-meta-sep" aria-hidden="true">·</span>}
                                                <span>{part}</span>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="application-desired-salary-container">
                            <p>{application?.candidate?.profile?.lookingFor?.idealSalaryCurrency && application?.candidate?.profile?.lookingFor?.idealSalary ? this.handleCurrency(application.candidate.profile.lookingFor.idealSalaryCurrency)+application.candidate.profile.lookingFor.idealSalary+" per month"  : "N/A" }</p>
                        </div>
                        <div className="application-job-match-container">
                            <CircularProgressbarWithChildren
                                className="progress-bar"
                                value={jobMatch}
                                maxValue={100}
                                strokeWidth={4}
                                styles={buildStyles({
                                    pathColor: "#1377FF",
                                })}
                            >
                                <div className="progress-bar-inside-container">
                                    <span>{jobMatch}%</span>
                                </div>
                            </CircularProgressbarWithChildren>
                        </div>
                        <div className="application-profile-completion-container">
                            <CircularProgressbarWithChildren
                                className="progress-bar"
                                value={application.candidate.percent}
                                maxValue={100}
                                strokeWidth={4}
                                styles={buildStyles({
                                    pathColor: "#1377FF",
                                })}
                            >
                                <div className="progress-bar-inside-container">
                                    <span>{application.candidate.percent}%</span>
                                </div>
                            </CircularProgressbarWithChildren>
                        </div>
                    </Link>
                    <div className="application-row-actions">
                        {status === "rejected" ? (
                            <button
                                type="button"
                                className="application-row-action application-row-action--ghost"
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.handleRestore(application._id); }}
                            >
                                Restore
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="application-row-action application-row-action--reject"
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.handleReject(application._id); }}
                            >
                                Reject
                            </button>
                        )}
                    </div>
                </div>
            );
        });

    }

    sortByType = (users, type) => {

        if (type === "JOB_MATCH_BEST") return users.sort(this.jobMatchBest);
        if (type === "JOB_MATCH_WORST") return users.sort(this.jobMatchWorst);
        if (type === "LAST_ACTIVE_LATEST") return users.sort(this.lastActiveLatest);
        if (type === "LAST_ACTIVE_EARLIEST") return users.sort(this.lastActiveEarliest);

        return users;

    }

    lastActiveLatest = (a, b) => {
     
        if (a.lastActive > b.lastActive) return -1;
        if (a.lastActive < b.lastActive) return 1;
            
        return 0;
    
    }

    lastActiveEarliest = (a, b) => {
     
        if (a.lastActive < b.lastActive) return -1;
        if (a.lastActive > b.lastActive) return 1;
            
        return 0;
    
    }

    jobMatchBest = (a, b) => {
     
        if (a.jobMatch > b.jobMatch) return -1;
        if (a.jobMatch < b.jobMatch) return 1;
            
        return 0;
    
    }

    jobMatchWorst = (a, b) => {
     
        if (a.jobMatch < b.jobMatch) return -1;
        if (a.jobMatch > b.jobMatch) return 1;
            
        return 0;
    
    }

    renderFilterResults = (users, job) => {

        let results = users.map(user => {
            return {
                ...user,
                jobMatch: getJobMatch(job, user),
            };
        });

        results = this.sortByType(results, this.state.resultsSortType);

        return results.map((user, index) => {

            return(
                <div key={index} className="application-row-container">
                    <div className="application-row-select-email-contianer">
                        {this.state.selectedForSending.includes(user._id) ?
                            <div className="application-row-select-email-outer-active-contianer" onClick={() => this.setState({ allSelected: false, selectedForSending: this.state.selectedForSending.filter(item => item !== user._id) })}>
                                <img src={require("../../../../assets/svgs/tick.svg")} alt="" />
                            </div>
                        :
                            <div className="application-row-select-email-outer-contianer" onClick={() => this.setState({ selectedForSending: [...this.state.selectedForSending, user._id] })}>
                            </div>
                        }
                    </div>
                    <a href={"/crew/profile/"+user._id} target={"_blank"} rel="noopener noreferrer" className="application-row-clickable-container">
                        <div className="application-row-details-container">
                            <div className="application-row-image-container">
                                <img src={user.profileImage || require("../../../../assets/svgs/avatar-placeholder.svg")} onError={(e) => e.target.src = require("../../../../assets/svgs/avatar-placeholder.svg")} alt="" />
                            </div>
                            <div className="application-row-name-container">
                                <p>{user.firstName} {user.lastName}</p>
                            </div>
                        </div>
                        <div className="application-desired-salary-container">
                            <p>{user?.lastActive ? timeSinceLastActive(user.lastActive)+" ago" : "N/A"}</p>
                        </div>
                        <div className="application-desired-salary-container">
                            <p>{user?.lookingFor?.idealSalaryCurrency && user?.lookingFor?.idealSalary ? this.handleCurrency(user.lookingFor.idealSalaryCurrency)+user.lookingFor.idealSalary+" per month"  : "N/A" }</p>
                        </div>
                        <div className="application-job-match-container">
                            <CircularProgressbarWithChildren
                                className="progress-bar"
                                value={user.jobMatch}
                                maxValue={100}
                                strokeWidth={4}
                                styles={buildStyles({
                                    pathColor: "#1377FF",
                                })}
                            >
                                <div className="progress-bar-inside-container">
                                    <span>{user.jobMatch}%</span>
                                </div>
                            </CircularProgressbarWithChildren>
                        </div>
                        <div className="application-profile-completion-container">
                            <CircularProgressbarWithChildren
                                className="progress-bar"
                                value={user.percent}
                                maxValue={100}
                                strokeWidth={4}
                                styles={buildStyles({
                                    pathColor: "#1377FF",
                                })}
                            >
                                <div className="progress-bar-inside-container">
                                    <span>{user.percent}%</span>
                                </div>
                            </CircularProgressbarWithChildren>
                        </div>
                    </a>
                </div>
            );
        });
    
    }

    renderSent = (users, job) => {

        let results = users.map(user => {
            return {
                ...user,
                jobMatch: getJobMatch(job, user),
            };
        });

        results = this.sortByType(results, this.state.resultsSortType);

        return results.map((user, index) => {

            return(
                <div key={index} className="application-row-container">
                    <a href={"/crew/profile/"+user._id} target={"_blank"} rel="noopener noreferrer" className="application-row-clickable-container">
                        <div className="application-row-details-container">
                            <div className="application-row-image-container">
                                <img src={user.profileImage || require("../../../../assets/svgs/avatar-placeholder.svg")} onError={(e) => e.target.src = require("../../../../assets/svgs/avatar-placeholder.svg")} alt="" />
                            </div>
                            <div className="application-row-name-container">
                                <p>{user.firstName} {user.lastName}</p>
                            </div>
                        </div>
                        <div className="application-desired-salary-container">
                            <p>{user?.lastActive ? timeSinceLastActive(user.lastActive)+" ago" : "N/A"}</p>
                        </div>
                        <div className="application-desired-salary-container">
                            <p>{user?.lookingFor?.idealSalaryCurrency && user?.lookingFor?.idealSalary ? this.handleCurrency(user.lookingFor.idealSalaryCurrency)+user.lookingFor.idealSalary+" per month"  : "N/A" }</p>
                        </div>
                        <div className="application-job-match-container">
                            <CircularProgressbarWithChildren
                                className="progress-bar"
                                value={user.jobMatch}
                                maxValue={100}
                                strokeWidth={4}
                                styles={buildStyles({
                                    pathColor: "#1377FF",
                                })}
                            >
                                <div className="progress-bar-inside-container">
                                    <span>{user.jobMatch}%</span>
                                </div>
                            </CircularProgressbarWithChildren>
                        </div>
                    </a>
                </div>
            );
        });

    }

    handleSelectAll = () => {

        let selected = [];

        this.state.filterResults.forEach(item => {
            if (!this.state.selectedForSending.includes(item._id)) {
                selected = [...selected, item._id];
            }
        });

        return this.setState({ allSelected: true, selectedForSending: [...this.state.selectedForSending, ...selected] });

    }

    /* Fire the actual match-to-job request and stash the trimmed results.
       Pulled out so presets and individual filter changes can reuse it. */
    triggerMatch = (debounceMs = 60) => {
        const job = this.state.job;
        if (!this.checkIfSearching()) {
            return this.setState({
                filterResults: [],
                appliedHiddenCount: 0,
                displayLimit: 50,
                isFetchingSearchResults: false,
            });
        }
        return this.setState({ isFetchingSearchResults: true }, () => {
            if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
            this.searchTimeOut = setTimeout(() => {
                return matchUserToJob(this.state, job).then(results => {
                    const all = [...this.state.active, ...this.state.rejected, ...this.state.forwarded, ...this.state.hired];
                    const emails = all.map(item => item.candidate.email);
                    const filtered = results.filter(result => !emails.includes(result.email));
                    return this.setState({
                        filterResults: filtered,
                        appliedHiddenCount: results.length - filtered.length,
                        displayLimit: 50,
                        isFetchingSearchResults: false,
                    });
                });
            }, debounceMs);
        });
    };

    filterSearch(propName, value, job) {

        return this.setState({ [propName]: value, filterTab: "results", openFilter: null }, () => {

            const isSearching = this.checkIfSearching();

            if (propName === "name" && !isSearching && this.state.name.length < 5) return;
            if (propName === "country" && !isSearching && this.state.country.length < 5) return;
            if (propName === "nationality" && !isSearching && this.state.nationality.length < 5) return;

            if (!isSearching) {
                return this.setState({
                    filterResults: [],
                    appliedHiddenCount: 0,
                    displayLimit: 50,
                    isFetchingSearchResults: false,
                });
            }

            const debounce = ["name", "country", "nationality"].includes(propName) ? 1000 : 60;

            if (propName === "location") {
                return geocodeByAddress(value)
                    .then(results => getLatLng(results[0]).then(data => {
                        return this.setState({ coords: data }, () => this.triggerMatch(60));
                    }));
            }

            return this.triggerMatch(debounce);

        });

    }

    /* One-click presets that set a coherent group of filter values and search. */
    applyPreset = (preset) => {
        const baseReset = {
            name: "", position: false, jobType: false, yachtType: false,
            couples: "Include Couples", qualifications: false, visas: false,
            location: "", coords: null, nationality: "", country: "",
            lastActive: "Don't Match", availability: "Don't Match",
            tattoo: false, smoking: false,
            yachtLengthMin: "", yachtLengthMax: "", yachtLengthAny: true,
            ageMin: "", ageMax: "", ageAny: true,
            salaryMin: "", salaryMax: "", salaryAny: true,
            salaryCurrency: null,
            profileKeywords: [], profileKeyword: "",
            positions: [], positionsSearch: "",
        };
        const presets = {
            bestFit: { position: true, jobType: true, yachtType: true, qualifications: true },
            recentlyActive: { lastActive: "Last Week" },
            available: { availability: "Immediate" },
            couples: { couples: "Only Couples" },
        };
        const next = { ...baseReset, ...(presets[preset] || {}), openFilter: null, filterTab: "results" };
        this.setState(next, () => this.triggerMatch(60));
    };

    toggleFilter = (name) => {
        this.setState({ openFilter: this.state.openFilter === name ? null : name });
    };

    /* Multi-select position helpers */
    togglePosition = (positionId) => {
        const current = this.state.positions || [];
        const next = current.includes(positionId)
            ? current.filter(id => id !== positionId)
            : [...current, positionId];
        // Explicit list always wins; clear the legacy "match this job" boolean.
        return this.setState({ positions: next, position: false }, () => this.triggerMatch(60));
    };

    useJobPosition = () => {
        return this.setState({ positions: [], position: true }, () => this.triggerMatch(60));
    };

    clearPositions = () => {
        return this.setState({ positions: [], position: false, positionsSearch: "" }, () => this.triggerMatch(60));
    };

    positionChipValueLabel = () => {
        const s = this.state;
        if (s.positions && s.positions.length > 0) {
            const names = s.positions
                .map(id => (s.availablePositions || []).find(x => x._id === id))
                .filter(Boolean)
                .map(p => p.name);
            if (names.length === 0) return `${s.positions.length} selected`;
            if (names.length === 1) return names[0];
            return `${names[0]} +${names.length - 1}`;
        }
        if (s.position) return "Matches this job";
        return null;
    };

    closeFilters = () => {
        if (this.state.openFilter) this.setState({ openFilter: null });
    };

    loadMore = () => {
        this.setState({ displayLimit: this.state.displayLimit + 50 });
    };

    resetState =  () => {

        return this.setState({
            filterTab: "results",
            filterResults: [],
            sent: [],
            selectedForSending: [],
            allSelected: false,  
            /* Filters */
            name: "",          
            position: false,
            jobType: false,
            yachtType: false,
            couples: "Include Couples",
            qualifications: false,
            visas: false,
            location: "",
            coords: null,
            nationality: "",
            country: "",
            lastActive: "Don't Match",
            availability: "Don't Match",
            tattoo: false,
            smoking: false,
            yachtLengthMin: "",
            yachtLengthMax: "",
            yachtLengthAny: true,
            ageMin: "",
            ageMax: "",
            ageAny: true,
            salaryMin: "",
            salaryMax: "",
            salaryAny: true,
            salaryCurrency: null,
            profileKeywords: [],
            profileKeyword: "",
            /* Opens */
            positionOpen: false,
            contractOpen: false,
            yachtTypeOpen: false,
            coupleOpen: false,
            qualificationsOpen: false,
            visasOpen: false,
            lastActiveOpen: false,
            availabilityOpen: false,
            tattooOpen: false,
            smokingOpen: false,
            salaryCurrencyOpen: false,
        });

    }

    handleSendJobAlerts = (_id, list) => {

        list = [...list, ...this.state.selectedForSending];

        return sendJobAlerts(_id, list, this.state.selectedForSending)
            .then(result => {
                this.resetState();
                return this.setState({ sent: result }, () => {

                    this.props.setAlert("Emails have been sent out!", "success", true);
                    setTimeout(() => {
                        return this.props.setAlert("Emails have been sent out!", "success", false);
                    }, 2700);

                    return getJob(this.props.match.params.jobId)
                        .then(job => { 
                            return this.setState({ job });
                        });
                });
            });

    }

    renderPlaceholders = () => {

        return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((_, index) => {
            return(
                <div className="listing-applications-list-item-placeholder" key={index}>
                </div>
            );
        });

    }

    handleSalaryCurrency = (curr) => {

        if (curr === "usd") return "Dollars ($)";
        if (curr === "eur") return "Euros (€)";
        if (curr === "gbp") return "Pounds (£)";

        return "Don't Match";

    }

    addProfileKeyword = (e, keyword) => {

        if (e.key === "Enter") {
            return this.setState({ profileKeywords: [...this.state.profileKeywords, keyword] }, () => {
                return this.setState({ profileKeyword: "" }, () => {
                    return this.filterSearch("profileKeywords", this.state.profileKeywords, this.state.job)
                });
            });
        }

    }

    removeKeyword = (item) => {

        return this.setState({ profileKeywords: this.state.profileKeywords.filter(keyword => keyword !== item) }, () => {
            return this.filterSearch("profileKeywords", this.state.profileKeywords, this.state.job);
        });

    }

    render() {

        let isSearching = this.checkIfSearching();
        const yacht = this.state.yacht;
        const yachtName = yacht ? handleYachtName(yacht) : "";
        const positionName = this.state?.job?.position?.name || "";

        return(
            <div className="admin-page listings-applications-master-container">
                <header className="admin-page-header">
                    <div className="admin-page-header-titles">
                        <h1 className="admin-page-title">{positionName || "Applications"}</h1>
                        {yachtName && <p className="admin-page-subtitle">{yachtName}</p>}
                    </div>
                    <button
                        type="button"
                        className={`admin-page-action ${this.state.findCandidates ? "admin-page-action--ghost" : "admin-page-action--primary"}`}
                        onClick={() => this.setState({ findCandidates: !this.state.findCandidates })}
                    >
                        {this.state.findCandidates ? "Hide filters" : "Find candidates"}
                    </button>
                </header>
                {!this.state.findCandidates ?
                    <>
                        <div className="admin-toolbar">
                            <nav className="admin-tabs" aria-label="Application status">
                                <Link
                                    to={this.props.match.path.includes("/yachts") ? `/yachts/listings/${this.props.match.params.yachtId}/applications/${this.props.match.params.jobId}` : `/listings/applications/${this.props.match.params.yachtId}/job/${this.props.match.params.jobId}`}
                                    className={`admin-tab${!this.props.match.params.tab ? " is-active" : ""}`}
                                >
                                    <span className="admin-tab-label">Active</span>
                                    {this.state.active.length > 0 && <span className="admin-tab-count">{this.state.active.length}</span>}
                                </Link>
                                <Link
                                    to={this.props.match.path.includes("/yachts") ? `/yachts/listings/${this.props.match.params.yachtId}/applications/${this.props.match.params.jobId}/rejected` : `/listings/applications/${this.props.match.params.yachtId}/job/${this.props.match.params.jobId}/rejected`}
                                    className={`admin-tab${this.props.match.params.tab === "rejected" ? " is-active" : ""}`}
                                >
                                    <span className="admin-tab-label">Rejected</span>
                                    {this.state.rejected.length > 0 && <span className="admin-tab-count">{this.state.rejected.length}</span>}
                                </Link>
                            </nav>
                        </div>
                        <div className="yacht-listing-list-contianer">
                            {this.state[this.props.match.params.tab ? this.props.match.params.tab : "active"].length > 0 &&
                                <div className="yacht-listing-list-header-container applications-list-header">
                                    <div className="yacht-listing-list-header-position-container">
                                        <p>Details</p>
                                    </div>
                                    <div className="yacht-listing-list-header-start-date-container">
                                        <p>Desired Salary</p>
                                    </div>
                                    <div className="yacht-listing-list-header-job-match-container">
                                        <p>Job Match</p>
                                    </div>
                                    <div className="yacht-listing-list-header-profile-completion-container">
                                        <p>Profile</p>
                                    </div>
                                    <div className="application-row-actions-spacer" aria-hidden="true"></div>
                                </div>
                            }
                            {this.state.isFetching && this.renderPlaceholders()}
                            {!this.state.isFetching && this.state[this.props.match.params.tab ? this.props.match.params.tab : "active"].length < 1 &&
                                <p className="admin-empty-state">{this.props.match.params.tab === "rejected" ? "No rejected candidates yet." : "No active applications yet. Try Find candidates to source crew."}</p>
                            }
                            {!this.props.match.params.tab && !this.state.isFetching &&
                                this.renderRows(this.state.active, "active")
                            }
                            {this.props.match.params.tab === "rejected" && !this.state.isFetching &&
                                this.renderRows(this.state.rejected, "rejected")
                            }
                        </div>
                    </>
                :
                    (() => {
                        const s = this.state;
                        const open = s.openFilter;
                        const visibleResults = (s.filterResults || []).slice(0, s.displayLimit);
                        const totalResults = (s.filterResults || []).length;
                        const anyFilterActive = isSearching;
                        const activePresetClass = (key) => {
                            if (key === "bestFit") return s.position && s.jobType && s.yachtType && s.qualifications;
                            if (key === "recentlyActive") return s.lastActive === "Last Week" && !s.position && !s.jobType;
                            if (key === "available") return s.availability === "Immediate";
                            if (key === "couples") return s.couples === "Only Couples";
                            return false;
                        };
                        return (
                        <>
                        <div className="fc-toolbar">
                            <div className="fc-presets" role="group" aria-label="Quick filters">
                                <button type="button" className={`fc-preset${!anyFilterActive ? " is-active" : ""}`} onClick={() => this.applyPreset("all")}>All candidates</button>
                                <button type="button" className={`fc-preset${activePresetClass("bestFit") ? " is-active" : ""}`} onClick={() => this.applyPreset("bestFit")}>Best fit for this job</button>
                                <button type="button" className={`fc-preset${activePresetClass("recentlyActive") ? " is-active" : ""}`} onClick={() => this.applyPreset("recentlyActive")}>Recently active</button>
                                <button type="button" className={`fc-preset${activePresetClass("available") ? " is-active" : ""}`} onClick={() => this.applyPreset("available")}>Available now</button>
                                <button type="button" className={`fc-preset${activePresetClass("couples") ? " is-active" : ""}`} onClick={() => this.applyPreset("couples")}>Couples only</button>
                            </div>
                            <div className="fc-toolbar-actions">
                                {anyFilterActive &&
                                    <button type="button" className="fc-reset" onClick={() => this.applyPreset("all")}>Reset filters</button>
                                }
                                {s.isFetchingSearchResults &&
                                    <span className="fc-status" role="status" aria-live="polite">
                                        <span className="fc-spinner" aria-hidden="true"></span>
                                        <span className="fc-status-text">Searching…</span>
                                    </span>
                                }
                            </div>
                        </div>

                        <div className="fc-search-row">
                            <div className="fc-search">
                                <span className="fc-search-icon">
                                    <img src={require("../../../../assets/svgs/search.svg")} alt="" />
                                </span>
                                <input
                                    type="text"
                                    className="fc-search-input"
                                    placeholder="Search candidate name (min 5 chars)"
                                    value={s.name}
                                    onChange={(e) => this.filterSearch("name", e.target.value, s.job)}
                                />
                            </div>
                        </div>

                        <div className="fc-chips" onClick={(e) => {
                            // close popovers when clicking the bare chip strip
                            if (e.target === e.currentTarget) this.closeFilters();
                        }}>
                            <FilterChip
                                label="Position"
                                valueLabel={this.positionChipValueLabel()}
                                isActive={s.position || (s.positions && s.positions.length > 0)}
                                isOpen={open === "position"}
                                onToggle={() => this.toggleFilter("position")}
                                onClear={this.clearPositions}
                            >
                                <div className="fc-section">
                                    <input
                                        type="text"
                                        className="fc-text-input"
                                        placeholder={`Search positions${s.job?.position?.name ? ` — try "${s.job.position.name}"` : ""}`}
                                        value={s.positionsSearch || ""}
                                        onChange={(e) => this.setState({ positionsSearch: e.target.value })}
                                        autoFocus
                                    />
                                </div>
                                <div className="fc-multi-list">
                                    {!s.positionsSearch && s.job?.position?._id && (
                                        <button
                                            type="button"
                                            className={`fc-option fc-option--preset${s.position && (!s.positions || s.positions.length === 0) ? " is-selected" : ""}`}
                                            onClick={this.useJobPosition}
                                        >
                                            <span className="fc-option-check" aria-hidden="true">{s.position && (!s.positions || s.positions.length === 0) ? "✓" : ""}</span>
                                            <span className="fc-option-label">
                                                <span className="fc-option-primary">Matches this job</span>
                                                <span className="fc-option-meta">{s.job.position.name}</span>
                                            </span>
                                        </button>
                                    )}
                                    {(() => {
                                        const q = (s.positionsSearch || "").trim().toLowerCase();
                                        const sorted = [...(s.availablePositions || [])].sort((a, b) => {
                                            const t = (a.positionType || "").localeCompare(b.positionType || "");
                                            if (t !== 0) return t;
                                            return (a.order || 0) - (b.order || 0);
                                        });
                                        const filtered = q
                                            ? sorted.filter(p => (p.name || "").toLowerCase().includes(q) || (p.positionType || "").toLowerCase().includes(q))
                                            : sorted;
                                        if (filtered.length === 0) {
                                            return <p className="fc-multi-empty">No positions match "{s.positionsSearch}".</p>;
                                        }
                                        return filtered.map(p => {
                                            const checked = (s.positions || []).includes(p._id);
                                            return (
                                                <button
                                                    type="button"
                                                    key={p._id}
                                                    className={`fc-option${checked ? " is-selected" : ""}`}
                                                    onClick={() => this.togglePosition(p._id)}
                                                >
                                                    <span className="fc-option-check fc-option-check--box" aria-hidden="true">{checked ? "✓" : ""}</span>
                                                    <span className="fc-option-label">
                                                        <span className="fc-option-primary">{p.name}</span>
                                                        {p.positionType && <span className="fc-option-meta">{p.positionType}</span>}
                                                    </span>
                                                </button>
                                            );
                                        });
                                    })()}
                                </div>
                                {(s.positions && s.positions.length > 0) && (
                                    <div className="fc-multi-footer">
                                        <span>{s.positions.length} selected</span>
                                        <button type="button" className="fc-multi-clear" onClick={this.clearPositions}>Clear</button>
                                    </div>
                                )}
                            </FilterChip>

                            <FilterChip
                                label="Contract"
                                valueLabel={s.jobType ? "Matches this job" : null}
                                isActive={s.jobType}
                                isOpen={open === "contract"}
                                onToggle={() => this.toggleFilter("contract")}
                                onClear={() => this.filterSearch("jobType", false, s.job)}
                            >
                                <FilterOption label="Matches this job's contract type" selected={s.jobType} onClick={() => this.filterSearch("jobType", true, s.job)} />
                                <FilterOption label="Any contract type" selected={!s.jobType} onClick={() => this.filterSearch("jobType", false, s.job)} />
                            </FilterChip>

                            <FilterChip
                                label="Yacht type"
                                valueLabel={s.yachtType ? "Matches this job" : null}
                                isActive={s.yachtType}
                                isOpen={open === "yachtType"}
                                onToggle={() => this.toggleFilter("yachtType")}
                                onClear={() => this.filterSearch("yachtType", false, s.job)}
                            >
                                <FilterOption label="Matches this job's yacht type" selected={s.yachtType} onClick={() => this.filterSearch("yachtType", true, s.job)} />
                                <FilterOption label="Any yacht type" selected={!s.yachtType} onClick={() => this.filterSearch("yachtType", false, s.job)} />
                            </FilterChip>

                            <FilterChip
                                label="Qualifications"
                                valueLabel={s.qualifications ? "Matches this job" : null}
                                isActive={s.qualifications}
                                isOpen={open === "qualifications"}
                                onToggle={() => this.toggleFilter("qualifications")}
                                onClear={() => this.filterSearch("qualifications", false, s.job)}
                            >
                                <FilterOption label="Has this job's qualifications" selected={s.qualifications} onClick={() => this.filterSearch("qualifications", true, s.job)} />
                                <FilterOption label="Any qualifications" selected={!s.qualifications} onClick={() => this.filterSearch("qualifications", false, s.job)} />
                            </FilterChip>

                            <FilterChip
                                label="Visas"
                                valueLabel={s.visas ? "Matches this job" : null}
                                isActive={s.visas}
                                isOpen={open === "visas"}
                                onToggle={() => this.toggleFilter("visas")}
                                onClear={() => this.filterSearch("visas", false, s.job)}
                            >
                                <FilterOption label="Has this job's visas" selected={s.visas} onClick={() => this.filterSearch("visas", true, s.job)} />
                                <FilterOption label="Any visa status" selected={!s.visas} onClick={() => this.filterSearch("visas", false, s.job)} />
                            </FilterChip>

                            <FilterChip
                                label="Couples"
                                valueLabel={s.couples !== "Include Couples" ? s.couples : null}
                                isActive={s.couples !== "Include Couples"}
                                isOpen={open === "couples"}
                                onToggle={() => this.toggleFilter("couples")}
                                onClear={() => this.filterSearch("couples", "Include Couples", s.job)}
                            >
                                <FilterOption label="Include couples" selected={s.couples === "Include Couples"} onClick={() => this.filterSearch("couples", "Include Couples", s.job)} />
                                <FilterOption label="No couples" selected={s.couples === "No Couples"} onClick={() => this.filterSearch("couples", "No Couples", s.job)} />
                                <FilterOption label="Only couples" selected={s.couples === "Only Couples"} onClick={() => this.filterSearch("couples", "Only Couples", s.job)} />
                            </FilterChip>

                            <FilterChip
                                label="Last active"
                                valueLabel={s.lastActive !== "Don't Match" ? s.lastActive : null}
                                isActive={s.lastActive !== "Don't Match"}
                                isOpen={open === "lastActive"}
                                onToggle={() => this.toggleFilter("lastActive")}
                                onClear={() => this.filterSearch("lastActive", "Don't Match", s.job)}
                            >
                                <FilterOption label="Last week" selected={s.lastActive === "Last Week"} onClick={() => this.filterSearch("lastActive", "Last Week", s.job)} />
                                <FilterOption label="Last month" selected={s.lastActive === "Last Month"} onClick={() => this.filterSearch("lastActive", "Last Month", s.job)} />
                                <FilterOption label="Last 2 months" selected={s.lastActive === "Last 2 Months"} onClick={() => this.filterSearch("lastActive", "Last 2 Months", s.job)} />
                                <FilterOption label="Any time" selected={s.lastActive === "Don't Match"} onClick={() => this.filterSearch("lastActive", "Don't Match", s.job)} />
                            </FilterChip>

                            <FilterChip
                                label="Availability"
                                valueLabel={s.availability !== "Don't Match" ? s.availability : null}
                                isActive={s.availability !== "Don't Match"}
                                isOpen={open === "availability"}
                                onToggle={() => this.toggleFilter("availability")}
                                onClear={() => this.filterSearch("availability", "Don't Match", s.job)}
                            >
                                <FilterOption label="Immediate" selected={s.availability === "Immediate"} onClick={() => this.filterSearch("availability", "Immediate", s.job)} />
                                <FilterOption label="Within 1 week" selected={s.availability === "Available in 1 week"} onClick={() => this.filterSearch("availability", "Available in 1 week", s.job)} />
                                <FilterOption label="Within 2 weeks" selected={s.availability === "Available in 2 weeks"} onClick={() => this.filterSearch("availability", "Available in 2 weeks", s.job)} />
                                <FilterOption label="4+ weeks" selected={s.availability === "Available in 4+ weeks"} onClick={() => this.filterSearch("availability", "Available in 4+ weeks", s.job)} />
                                <FilterOption label="Any availability" selected={s.availability === "Don't Match"} onClick={() => this.filterSearch("availability", "Don't Match", s.job)} />
                            </FilterChip>

                            <FilterChip
                                label="Where"
                                valueLabel={(s.location || (s.nationality.length >= 5 ? s.nationality : "") || (s.country.length >= 5 ? s.country : "")) || null}
                                isActive={!!(s.location || s.nationality.length >= 5 || s.country.length >= 5)}
                                isOpen={open === "where"}
                                onToggle={() => this.toggleFilter("where")}
                                onClear={() => this.setState({ location: "", coords: null, nationality: "", country: "" }, () => this.triggerMatch(60))}
                            >
                                <div className="fc-section">
                                    <p className="fc-section-label">Current location</p>
                                    <PlacesAutocomplete
                                        value={s.location}
                                        onChange={(value) => this.setState({ location: value })}
                                        onSelect={(value) => this.filterSearch("location", value, s.job)}
                                    >
                                        {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                                            <div className="fc-where-location">
                                                <input className="fc-text-input" {...getInputProps({ placeholder: "Search a place" })} />
                                                {suggestions.length > 0 &&
                                                    <div className="fc-where-suggestions">
                                                        {suggestions.map((suggestion, index) => (
                                                            <div key={index} className="fc-where-suggestion" {...getSuggestionItemProps(suggestion)}>
                                                                <p>{suggestion.description}</p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                }
                                            </div>
                                        )}
                                    </PlacesAutocomplete>
                                </div>
                                <div className="fc-section">
                                    <p className="fc-section-label">Nationality</p>
                                    <input className="fc-text-input" type="text" placeholder="e.g. British" value={s.nationality} onChange={(e) => this.filterSearch("nationality", e.target.value, s.job)} />
                                </div>
                                <div className="fc-section">
                                    <p className="fc-section-label">Country of residence</p>
                                    <input className="fc-text-input" type="text" placeholder="e.g. France" value={s.country} onChange={(e) => this.filterSearch("country", e.target.value, s.job)} />
                                </div>
                            </FilterChip>

                            <FilterChip
                                label="Salary"
                                valueLabel={(!s.salaryAny && (s.salaryMin || s.salaryMax)) ? `${this.handleCurrency(s.salaryCurrency) || ""}${s.salaryMin || "0"}–${s.salaryMax || "∞"}/mo` : (s.salaryCurrency ? this.handleSalaryCurrency(s.salaryCurrency) : null)}
                                isActive={!!s.salaryCurrency || (!s.salaryAny && (s.salaryMin || s.salaryMax))}
                                isOpen={open === "salary"}
                                onToggle={() => this.toggleFilter("salary")}
                                onClear={() => this.setState({ salaryMin: "", salaryMax: "", salaryAny: true, salaryCurrency: null }, () => this.triggerMatch(60))}
                            >
                                <div className="fc-section">
                                    <p className="fc-section-label">Currency</p>
                                    <div className="fc-segmented">
                                        <button type="button" className={`fc-segment${!s.salaryCurrency ? " is-active" : ""}`} onClick={() => this.filterSearch("salaryCurrency", null, s.job)}>Any</button>
                                        <button type="button" className={`fc-segment${s.salaryCurrency === "usd" ? " is-active" : ""}`} onClick={() => this.filterSearch("salaryCurrency", "usd", s.job)}>$</button>
                                        <button type="button" className={`fc-segment${s.salaryCurrency === "eur" ? " is-active" : ""}`} onClick={() => this.filterSearch("salaryCurrency", "eur", s.job)}>€</button>
                                        <button type="button" className={`fc-segment${s.salaryCurrency === "gbp" ? " is-active" : ""}`} onClick={() => this.filterSearch("salaryCurrency", "gbp", s.job)}>£</button>
                                    </div>
                                </div>
                                <div className="fc-section">
                                    <p className="fc-section-label">Monthly range</p>
                                    <div className="fc-range">
                                        <input className="fc-text-input fc-range-input" type="text" placeholder="Min" disabled={s.salaryAny} value={s.salaryMin} onChange={(e) => this.filterSearch("salaryMin", e.target.value, s.job)} />
                                        <span className="fc-range-sep">–</span>
                                        <input className="fc-text-input fc-range-input" type="text" placeholder="Max" disabled={s.salaryAny} value={s.salaryMax} onChange={(e) => this.filterSearch("salaryMax", e.target.value, s.job)} />
                                        <button type="button" className="fc-segment fc-range-toggle" onClick={() => this.setState({ salaryMin: "", salaryMax: "" }, () => this.filterSearch("salaryAny", !s.salaryAny, s.job))}>{s.salaryAny ? "Set" : "Any"}</button>
                                    </div>
                                </div>
                            </FilterChip>

                            <FilterChip
                                label="Yacht length"
                                valueLabel={(!s.yachtLengthAny && (s.yachtLengthMin || s.yachtLengthMax)) ? `${s.yachtLengthMin || "0"}–${s.yachtLengthMax || "∞"}m` : null}
                                isActive={!s.yachtLengthAny && (s.yachtLengthMin || s.yachtLengthMax)}
                                isOpen={open === "yachtLength"}
                                onToggle={() => this.toggleFilter("yachtLength")}
                                onClear={() => this.setState({ yachtLengthMin: "", yachtLengthMax: "", yachtLengthAny: true }, () => this.triggerMatch(60))}
                            >
                                <div className="fc-section">
                                    <p className="fc-section-label">Desired yacht length</p>
                                    <div className="fc-range">
                                        <input className="fc-text-input fc-range-input" type="text" placeholder="Min m" disabled={s.yachtLengthAny} value={s.yachtLengthMin} onChange={(e) => this.filterSearch("yachtLengthMin", e.target.value, s.job)} />
                                        <span className="fc-range-sep">–</span>
                                        <input className="fc-text-input fc-range-input" type="text" placeholder="Max m" disabled={s.yachtLengthAny} value={s.yachtLengthMax} onChange={(e) => this.filterSearch("yachtLengthMax", e.target.value, s.job)} />
                                        <button type="button" className="fc-segment fc-range-toggle" onClick={() => this.setState({ yachtLengthMin: "", yachtLengthMax: "" }, () => this.filterSearch("yachtLengthAny", !s.yachtLengthAny, s.job))}>{s.yachtLengthAny ? "Set" : "Any"}</button>
                                    </div>
                                </div>
                            </FilterChip>

                            <FilterChip
                                label="Age"
                                valueLabel={(!s.ageAny && (s.ageMin || s.ageMax)) ? `${s.ageMin || "0"}–${s.ageMax || "∞"}` : null}
                                isActive={!s.ageAny && (s.ageMin || s.ageMax)}
                                isOpen={open === "age"}
                                onToggle={() => this.toggleFilter("age")}
                                onClear={() => this.setState({ ageMin: "", ageMax: "", ageAny: true }, () => this.triggerMatch(60))}
                            >
                                <div className="fc-section">
                                    <p className="fc-section-label">Desired age</p>
                                    <div className="fc-range">
                                        <input className="fc-text-input fc-range-input" type="text" placeholder="Min" disabled={s.ageAny} value={s.ageMin} onChange={(e) => this.filterSearch("ageMin", e.target.value, s.job)} />
                                        <span className="fc-range-sep">–</span>
                                        <input className="fc-text-input fc-range-input" type="text" placeholder="Max" disabled={s.ageAny} value={s.ageMax} onChange={(e) => this.filterSearch("ageMax", e.target.value, s.job)} />
                                        <button type="button" className="fc-segment fc-range-toggle" onClick={() => this.setState({ ageMin: "", ageMax: "" }, () => this.filterSearch("ageAny", !s.ageAny, s.job))}>{s.ageAny ? "Set" : "Any"}</button>
                                    </div>
                                </div>
                            </FilterChip>

                            <FilterChip
                                label="Tattoos"
                                valueLabel={s.tattoo ? "Matches this job" : null}
                                isActive={s.tattoo}
                                isOpen={open === "tattoo"}
                                onToggle={() => this.toggleFilter("tattoo")}
                                onClear={() => this.filterSearch("tattoo", false, s.job)}
                            >
                                <FilterOption label="Matches this job's tattoo policy" selected={s.tattoo} onClick={() => this.filterSearch("tattoo", true, s.job)} />
                                <FilterOption label="Any tattoo status" selected={!s.tattoo} onClick={() => this.filterSearch("tattoo", false, s.job)} />
                            </FilterChip>

                            <FilterChip
                                label="Smoking"
                                valueLabel={s.smoking ? "Matches this job" : null}
                                isActive={s.smoking}
                                isOpen={open === "smoking"}
                                onToggle={() => this.toggleFilter("smoking")}
                                onClear={() => this.filterSearch("smoking", false, s.job)}
                            >
                                <FilterOption label="Matches this job's smoking policy" selected={s.smoking} onClick={() => this.filterSearch("smoking", true, s.job)} />
                                <FilterOption label="Any smoking status" selected={!s.smoking} onClick={() => this.filterSearch("smoking", false, s.job)} />
                            </FilterChip>

                            <FilterChip
                                label="Keywords"
                                valueLabel={s.profileKeywords.length > 0 ? `${s.profileKeywords.length} tag${s.profileKeywords.length === 1 ? "" : "s"}` : null}
                                isActive={s.profileKeywords.length > 0}
                                isOpen={open === "keywords"}
                                onToggle={() => this.toggleFilter("keywords")}
                                onClear={() => this.setState({ profileKeywords: [], profileKeyword: "" }, () => this.triggerMatch(60))}
                            >
                                <div className="fc-section">
                                    <p className="fc-section-label">Profile keywords (press Enter to add)</p>
                                    <div className="fc-tags-input">
                                        {s.profileKeywords.map((item, index) => (
                                            <span className="fc-tag" key={index}>
                                                {item}
                                                <button type="button" className="fc-tag-remove" onClick={() => this.removeKeyword(item)} aria-label={`Remove ${item}`}>×</button>
                                            </span>
                                        ))}
                                        <input
                                            className="fc-tag-input"
                                            type="text"
                                            placeholder={s.profileKeywords.length > 0 ? "" : "e.g. dive instructor"}
                                            value={s.profileKeyword}
                                            onChange={(e) => this.setState({ profileKeyword: e.target.value })}
                                            onKeyDown={(e) => this.addProfileKeyword(e, s.profileKeyword)}
                                        />
                                    </div>
                                </div>
                            </FilterChip>
                        </div>

                        <div className="admin-toolbar fc-results-tabs">
                            <nav className="admin-tabs" aria-label="Candidate search results">
                                <button
                                    type="button"
                                    className={`admin-tab${s.filterTab === "results" ? " is-active" : ""}`}
                                    onClick={() => this.setState({ filterTab: "results" })}
                                >
                                    <span className="admin-tab-label">Results</span>
                                    {totalResults > 0 && <span className="admin-tab-count">{totalResults}</span>}
                                </button>
                                <button
                                    type="button"
                                    className={`admin-tab${s.filterTab === "sent" ? " is-active" : ""}`}
                                    onClick={() => this.setState({ filterTab: "sent" })}
                                >
                                    <span className="admin-tab-label">Sent</span>
                                    {s.sent.length > 0 && <span className="admin-tab-count">{s.sent.length}</span>}
                                </button>
                            </nav>
                        </div>

                        {s.filterTab === "results" && anyFilterActive && totalResults > 0 &&
                            <div className="fc-meta">
                                <p className="fc-meta-count">
                                    Showing <strong>{Math.min(s.displayLimit, totalResults)}</strong> of <strong>{totalResults}</strong> matching candidates
                                </p>
                                {s.appliedHiddenCount > 0 &&
                                    <span className="fc-meta-pill" title="Already applied to this job">
                                        {s.appliedHiddenCount} already applied
                                    </span>
                                }
                            </div>
                        }

                        {s.filterTab === "results" && s.selectedForSending.length > 0 &&
                            <div className="fc-selection-bar">
                                <p className="fc-selection-text">
                                    <strong>{s.selectedForSending.length}</strong> selected
                                </p>
                                <div className="fc-selection-actions">
                                    <button
                                        type="button"
                                        className="admin-page-action admin-page-action--ghost"
                                        onClick={() => this.setState({ allSelected: false, selectedForSending: [] })}
                                    >
                                        Clear selection
                                    </button>
                                    <button
                                        type="button"
                                        className="admin-page-action admin-page-action--primary"
                                        onClick={() => this.handleSendJobAlerts(s.job._id, s.job.emailList)}
                                    >
                                        Send job alert
                                    </button>
                                </div>
                            </div>
                        }

                        {s.filterTab === "results" && totalResults > 0 && s.selectedForSending.length === 0 &&
                            <div className="fc-selection-bar">
                                <button
                                    type="button"
                                    className="admin-page-action admin-page-action--ghost"
                                    onClick={() => this.handleSelectAll()}
                                >
                                    Select all on this page
                                </button>
                            </div>
                        }

                        <div className="fc-results">
                            {s.isFetchingSearchResults &&
                                <div className="fc-progress" role="progressbar" aria-label="Searching">
                                    <span className="fc-progress-bar" />
                                </div>
                            }
                            {s.filterTab === "results" ?
                                <>
                                    {(totalResults > 0 || s.isFetchingSearchResults) &&
                                        <div className="yacht-listing-list-header-container fc-list-header">
                                            <div className="yacht-listing-list-header-position-container">
                                                <p>Details</p>
                                            </div>
                                            <div className="yacht-listing-list-header-start-date-container" style={{ cursor: "pointer" }} onClick={() => this.setState({ resultsSortType: s.resultsSortType === "LAST_ACTIVE_LATEST" ? "LAST_ACTIVE_EARLIEST" : "LAST_ACTIVE_LATEST" })}>
                                                <p>Last Active</p>
                                                {(s.resultsSortType === "LAST_ACTIVE_LATEST" || s.resultsSortType === "LAST_ACTIVE_EARLIEST") &&
                                                    <img src={require("../../../../assets/svgs/up-arrow.svg")} style={s.resultsSortType === "LAST_ACTIVE_LATEST" ? { transform: "rotate(180deg)" } : {}} alt="" />
                                                }
                                            </div>
                                            <div className="yacht-listing-list-header-start-date-container">
                                                <p>Desired Salary</p>
                                            </div>
                                            <div className="yacht-listing-list-header-job-match-container" style={{ cursor: "pointer" }} onClick={() => this.setState({ resultsSortType: s.resultsSortType === "JOB_MATCH_BEST" ? "JOB_MATCH_WORST" : "JOB_MATCH_BEST" })}>
                                                <p>Job Match</p>
                                                {(s.resultsSortType === "JOB_MATCH_BEST" || s.resultsSortType === "JOB_MATCH_WORST") &&
                                                    <img src={require("../../../../assets/svgs/up-arrow.svg")} style={s.resultsSortType === "JOB_MATCH_BEST" ? { transform: "rotate(180deg)" } : {}} alt="" />
                                                }
                                            </div>
                                            <div className="yacht-listing-list-header-job-match-container">
                                                <p>Profile</p>
                                            </div>
                                        </div>
                                    }
                                    {/* When fetching with no prior results, show skeleton rows so admin sees layout immediately. */}
                                    {s.isFetchingSearchResults && totalResults === 0 && (
                                        <div className="fc-skeletons" aria-hidden="true">
                                            {[0,1,2,3,4,5].map(i => <div key={i} className="listing-applications-list-item-placeholder" />)}
                                        </div>
                                    )}
                                    {this.renderFilterResults(visibleResults, s.job)}
                                    {totalResults > s.displayLimit &&
                                        <div className="admin-load-more">
                                            <button type="button" className="admin-page-action admin-page-action--ghost" onClick={this.loadMore}>
                                                See more candidates
                                            </button>
                                        </div>
                                    }
                                    {totalResults < 1 && !s.isFetchingSearchResults && anyFilterActive &&
                                        <p className="admin-empty-state">No candidates match these filters.</p>
                                    }
                                    {!anyFilterActive && !s.isFetchingSearchResults &&
                                        <p className="admin-empty-state">Pick a preset above or open a filter chip to start searching.</p>
                                    }
                                </>
                            :
                                <>
                                    {s.sent.length > 0 &&
                                        <div className="yacht-listing-list-header-container fc-list-header">
                                            <div className="yacht-listing-list-header-position-container">
                                                <p>Details</p>
                                            </div>
                                            <div className="yacht-listing-list-header-start-date-container">
                                                <p>Last Active</p>
                                            </div>
                                            <div className="yacht-listing-list-header-start-date-container">
                                                <p>Desired Salary</p>
                                            </div>
                                            <div className="yacht-listing-list-header-job-match-container">
                                                <p>Job Match</p>
                                            </div>
                                        </div>
                                    }
                                    {this.renderSent(s.sent, s.job)}
                                    {s.sent.length < 1 &&
                                        <p className="admin-empty-state">No job alerts sent yet from this listing.</p>
                                    }
                                </>
                            }
                        </div>
                        </>
                        );
                    })()
                }
            </div>
        );

    }

}

const mapStateToProps = (state) => {
    return {
        admin: state.admin,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators({ setAlert }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Applications);
